import React, { useEffect } from 'react';
import Dialog from 'src/components/common/Dialog';
import Button from 'src/components/controls/forms/redesign/FormButton';
import FlagNote from 'src/models/AP/FlagNote';
import RHFInputBox from 'src/components/controls/tempRHFControls/RHFInputBox';
import { useDispatch } from 'react-redux';
import actions from 'src/actions';
import DialogList from 'src/dialogs';

interface IViewFlagNotesDialogProps {
    dialogName: string;
    handleConfirm?: (reason: string) => void;
    hideDialog: () => void;
    label?: string;
    notes?: FlagNote[];
    setRelaunch?: (launch: boolean) => void;
    setNoteMode?: (mode: boolean) => void;
}

const ViewFlagNotesDialog = (props: IViewFlagNotesDialogProps) => {
    const dispatch = useDispatch();

    useEffect(() => {
        onCreate();
    }, []);

    useEffect(() => {
        if (!!props?.notes && props.notes?.length > 0) {
            console.log('wth!!');
        }
    }, [props.notes]);

    const onCreate = () => {
        console.log('DefineBudgetCategoryDialog onCreate()');
    };

    const displayFlagAndCorrectionNotes = () => {
        return <div>
            <table>
                <thead>
                    <tr>
                        <th>Owner</th>
                        <th>Created</th>
                        <th>Action</th>
                        <th>Note</th>
                    </tr>
                </thead>
                <tbody style={{width: '100%', maxHeight: '30vh', overflowY: 'scroll'}}>
                {props.notes?.length > 0 && props.notes?.map(
                    (n: FlagNote, index: number) => {
                    return (
                        <>
                            <tr className="table-item-hover" style={{ textAlign: 'center' }}>
                                <td style={{ width: '3%' }}>
                                    <RHFInputBox
                                        readOnly={true}                                        
                                        name={`owner`}
                                        defaultVal={n?.owner}
                                        type="text"
                                        style={{ width: '100%', background: '#d5f7f5' }}
                                        bodyStyle={{ width: '100%' }}
                                    />
                                </td>
                                <td style={{ width: '5%' }}>
                                    <RHFInputBox
                                        name={`date`}
                                        readOnly={true}
                                        defaultVal={n?.created?.toLocaleString()}
                                        type="text"
                                        style={{ width: '100%' }}
                                        bodyStyle={{ width: '100%' }}
                                    />
                                </td>
                                <td style={{ width: '3%' }}>
                                    <RHFInputBox
                                        name={`noteType`}
                                        readOnly={true}
                                        defaultVal={n?.type === 'F' ? 'Flag' : 'Correction'}
                                        type="text"
                                        style={n?.type === 'F' ? {backgroundColor: 'red', width: '100%' } : {backgroundColor: '#CC5500', width: '100%' }}
                                        bodyStyle={{ width: '100%' }}
                                    />
                                </td>
                                <td style={{ width: '10%' }}>
                                    <textarea
                                        id={'flagReasonDialogTextArea'}
                                        name={'flagReasonTextArea'}
                                        style={{width: '100%', height: '10rem', resize: 'none'}}
                                        value={n?.note}
                                    />
                                </td>
                            </tr>
                        </>
                    );
                })}
                
                </tbody>
            </table>
        </div>;
    };

    const showAddFlagOrCorrectionDialog = (mode: number) => {
        if (mode === 0) {
            props?.setNoteMode(false);
        } else {
            props?.setNoteMode(true);
        }
        props.setRelaunch(true);
        dispatch(actions.layout.showDialog(DialogList.FLAG_REASON_DIALOG));
        // alert(`Show the note entry dialog in the ${mode === 1 ? 'Correction' : 'Flag' } mode.`);
    };

    return (
        <Dialog title="Flag & Correction Notes" dialogName={props.dialogName} isExitButtonInvisible={false} bodyStyle={{ width: '50%' }}>
            <div className="form-row" style={{marginTop: '2rem', justifyContent: 'center'}}>
                <Button
                    className="blue-hover-button"
                    style={{ width: '24%', marginRight: '1rem' }}
                    text={'Add Correction'}
                    onClick={() => showAddFlagOrCorrectionDialog(1)}
                />
                <Button
                    className="blue-hover-button"
                    style={{ width: '24%', marginRight: '1rem' }}
                    text={'Add Flag'}
                    onClick={() => showAddFlagOrCorrectionDialog(0)}
                />
                <Button
                    className="blue-hover-button"
                    style={{ width: '24%', marginRight: '1rem' }}
                    text={'Close'}
                    onClick={() => props.hideDialog()}
                />
            </div>
            <div style={{ display: 'flex', justifyContent: 'center' }}>
                <form
                >
                    {displayFlagAndCorrectionNotes()}
                </form>
            </div>
        </Dialog>
    );
};

export default ViewFlagNotesDialog;



// WEBPACK FOOTER //
// ./src/components/project-billing/dialogs/ViewFlagNotesDialog.tsx